import { User } from '@/store/user/types';
import { isExpired, isTrialing } from '@/utils/subscriptions';

export const cannotExtendSubscription = (user?: User): boolean => {
	return (
		!!user &&
		(user.subscription?.type !== 'stripe' ||
			isTrialing(user.subscription) ||
			isExpired(user.subscription) ||
			!user.subscription?.is_canceled ||
			user.subscription.plan_duration !== 'year')
	);
};
